class Components {
    constructor() {

        (function( window, document, undefined ) {

            const components = document.querySelectorAll('.component');        

            function getPosComp(){
                let posComp = [];

                components.forEach(function(el){
                    let comp = new Object();
                    let bgmodify = (el.dataset.bgmodify) ? el.dataset.bgmodify : 0;
                    
                    comp.offsetTop = el.offsetTop;
                    comp.clientHeight = parseInt(el.clientHeight - bgmodify);
                    if(!el.classList.contains('component-service')){
                        posComp.push(comp);
                    }
                });

                return posComp;
            }

            function createBgs(){
                let componentsPos = getPosComp();
                let colors = [];
                            
                let elememt = document.createElement('div');
                elememt.className = 'backdrops';

                components.forEach(function(el){
                    colors.push(el.dataset.bg);
                });

                components.forEach(function(el,key){
                    elememt.innerHTML += `<div class="backdrop ${colors[key]}" style="top:${componentsPos[key].offsetTop}px; height:${componentsPos[key].clientHeight}px;"></div>`;
                    document.body.insertAdjacentElement('beforeend', elememt);
                    if(!isMobileSize()){
                        el.style.backgroundColor = 'transparent';   
                    }
                });

            }
            
            setTimeout(() => {
                createBgs();
            }, 1000);
            
            let backdrops = document.querySelectorAll('.backdrop');

            function setPosComp(){
                let componentsPos = getPosComp();

                if(!isMobileSize()){
                    backdrops.forEach(function(el,key){
                        el.style.top = `${componentsPos[key].offsetTop}px`;
                        el.style.height = `${componentsPos[key].clientHeight}px`;
                    });

                    components.forEach(function(el){
                        el.backgroundColor = 'transparent';
                    })
                } else {
                    components.forEach(function(el){
                        el.removeAttribute("style")
                    })
                }
            }

            function isMobileSize(){
                if (window.matchMedia("(max-width: 1024px)").matches) {
                  return true;
                } else {
                    return false;
                }
            }

            window.addEventListener("resize", setPosComp);
                                    
        }( window, document ));
      
        console.log('Components');

    }    
}

export default Components;